import { render } from "./case_owner_profile_modal.html?vue&type=template&id=0945fac9&external"
import script from "./case_owner_profile_modal.js?vue&type=script&lang=js&external"
export * from "./case_owner_profile_modal.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__